// Which of the two a reader is looking at: the picture as the product shows
// it, or the file exactly as it was imported.
//
// The choice belongs to the reader and follows them from one diagram to the
// next, so it is kept in this browser and nowhere else. Until they make one,
// the database's own view setting (`diagram.enhanceSvg`, Console -> Views)
// decides - the default is the product's opinion, the switch is the reader's.

export const ENHANCED = "enhanced";
export const ORIGINAL = "original";

const KEY = "bf.diagram.svgPresentation";

// Storage can be missing, full, or refuse to answer in a private window, and
// none of that is a reason for a diagram not to open - the same try/catch the
// rest of the app reads localStorage through.
export function readPreference() {
  try {
    const stored = window.localStorage.getItem(KEY);
    return stored === ENHANCED || stored === ORIGINAL ? stored : null;
  } catch (e) {
    return null;
  }
}

export function writePreference(value) {
  try {
    if (value === ENHANCED || value === ORIGINAL) window.localStorage.setItem(KEY, value);
    else window.localStorage.removeItem(KEY);
  } catch (e) {
    /* a reader whose browser keeps nothing still gets this session's choice */
  }
}

// What to ask the server for: the reader's own choice, else what the database
// is configured for.
export const presentationFor = (preference, enhanceByDefault) =>
  preference === ENHANCED || preference === ORIGINAL ? preference : enhanceByDefault === false ? ORIGINAL : ENHANCED;
